import { FormItem, Stack } from '@heathmont/moon-components';
import { Controller } from 'react-hook-form';
import FormCaptcha from '~/client/shared/form/FormCaptcha';
import FormCheckbox from '~/client/shared/form/FormCheckbox';
import DateInput from '~/client/shared/form/FormDateInput/DateInput';
import FormError from '~/client/shared/form/FormError';
import FormInput from '~/client/shared/form/FormInput';
import FormPhoneNumber from '~/client/shared/form/FormPhoneNumber';
import EmailSuggestion from './EmailSuggestion';
import Submit from './Submit';
import useFormRegister from './useFormRegister';
import BrandThemeProvider from '../../../Shared/BrandThemeProvider';

type Props = {
  isPopover?: boolean;
  onSubmitHandle?: () => void;
};

const FormRegister: FC<Props> = ({ onSubmitHandle, isPopover = false }) => {
  const {
    control,
    offersLabel,
    termsLabel,
    errors,
    loading,
    isCaptchaRequired,
    recaptchaRef,
    showEmailSuggestion,
    required,
    optional,
    handleSubmit,
    setValue,
    getValues,
    handleSelectedSuggestionEmail,
    usernameInputOptions,
    emailInputOptions,
  } = useFormRegister({ onSuccess: onSubmitHandle, isPopover });

  const handleOffersClick = () => {
    const offers = !getValues().offers;
    setValue('offersCall', offers);
    setValue('offersSms', offers);
  };
  const handleAcceptsTermsClick = () => {
    const acceptsTerms = getValues().acceptsTerms;
    setValue('acceptsTerms', !acceptsTerms);
  };
  return (
    <form>
      <Stack>
        <FormInput
          {...required('username', true, usernameInputOptions)}
          type="text"
          label="profile.username"
          autoCapitalize="off"
          error={errors.username?.message}
        />
        <FormInput
          {...required('email', true, emailInputOptions)}
          type="email"
          label="profile.email"
          autoCapitalize="off"
          error={errors.email?.message}
        />
        {showEmailSuggestion && (
          <EmailSuggestion
            handleSelectedSuggestionEmail={handleSelectedSuggestionEmail}
          />
        )}
        <Controller
          control={control}
          name="dateOfBirth"
          render={({ field: { onChange, onBlur } }) => (
            <FormItem>
              <DateInput
                name="dateOfBirth"
                error={errors.dateOfBirth?.day?.message}
                adultOnly
                onChange={onChange}
                onBlur={onBlur}
              />
            </FormItem>
          )}
        />
        <FormPhoneNumber
          control={control}
          {...optional('phone')}
          name="phone"
          label="profile.phone.optional"
          error={errors.phone?.message}
        />
        <FormInput
          {...required('password')}
          type="password"
          label="profile.password"
          error={errors.password?.message}
        />
        <BrandThemeProvider hasBombayClubTheme={isPopover}>
          <FormCheckbox
            {...required('acceptsTerms')}
            label={termsLabel}
            error={errors.acceptsTerms?.message}
            onClick={handleAcceptsTermsClick}
          />
          <FormCheckbox
            {...optional('offers')}
            label={offersLabel}
            onClick={handleOffersClick}
          />
          {isCaptchaRequired && (
            <FormCaptcha
              {...required('captcha', !!isCaptchaRequired)}
              name="captcha"
              control={control}
              error={errors.captcha?.message}
              ref={recaptchaRef}
            />
          )}
          <FormError message={errors.global?.message ?? ''} />
          <Submit loading={loading} handleSubmit={handleSubmit} />
        </BrandThemeProvider>
      </Stack>
    </form>
  );
};

export default FormRegister;
